import { useDispatch } from "react-redux";

import type { LeadsSearchRow } from "app/pages/sales-intelligence/modules/leads-search";
import { CompanyActionsCell } from "app/pages/sales-intelligence/modules/leads-search/components/cells/CompanyActionsCell/CompanyActionsCell";
import { getMainCompanyDomainOrDefault } from "app/pages/sales-intelligence/modules/leads-search/utils/rows";
import { useExportQuota } from "app/pages/sales-intelligence/modules/quota/hooks/useExportQuota";
import { exportDomainsToDynamicsThunk } from "app/pages/sales-intelligence/sub-modules/management/store/effects/dynamics/domainExport";
import { exportDomainsToHsThunk } from "app/pages/sales-intelligence/sub-modules/management/store/effects/hubspot/export";
import { exportDomainsToSFThunk } from "app/pages/sales-intelligence/sub-modules/management/store/effects/salesforce/export";
import { useCurrentOpportunityListCountry } from "app/pages/sales-intelligence/sub-modules/opportunities/hooks/useCurrentOpportunityListCountry";

import { useListParams } from "../../../context/ListParamsContext";
import trackingService from "../../../services/tracking/trackingService";

type Props = {
    record: LeadsSearchRow;
};

export const CompanyActionsCellContainer = ({ record }: Props) => {
    const dispatch = useDispatch();

    const { isQuotaAllowed } = useExportQuota();

    const listParams = useListParams();
    const listCountry = useCurrentOpportunityListCountry();

    const domain = getMainCompanyDomainOrDefault(record).domain;

    const handleHubSpotExport = () => {
        void dispatch(exportDomainsToHsThunk([domain], [listCountry], "companies", listParams.id));
        trackingService.trackActionsExportClick();
    };

    const handleSalesforceExport = () => {
        void dispatch(exportDomainsToSFThunk([domain], [listCountry], "companies", listParams.id));
        trackingService.trackActionsExportClick();
    };

    const handleDynamicsExport = () => {
        void dispatch(exportDomainsToDynamicsThunk([domain], [listCountry], "companies", listParams?.id));
        trackingService.trackActionsExportClick();
    };

    const handleMeetingAgentClick = () => {
        trackingService.trackActionsPrepareForMeetingClick();
    };

    const handleCraftEmailClick = () => {
        trackingService.trackActionsAiOutreachClick();
    };

    const handleDDToggle = (isOpen: boolean) => {
        if (isOpen) {
            trackingService.trackActionsDDClick();
        }
    };

    return (
        <CompanyActionsCell
            domain={domain}
            isExportQuotaAllowed={isQuotaAllowed}
            onHubSpotExport={handleHubSpotExport}
            onSalesforceExport={handleSalesforceExport}
            onDynamicsExport={handleDynamicsExport}
            onCraftEmailClick={handleCraftEmailClick}
            onMeetingAgentClick={handleMeetingAgentClick}
            onDDToggle={handleDDToggle}
        />
    );
};
